/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_empty_cart_title = /** @type {(inputs: {}) => string} */ () => {
	return `Prázdný košík`
};

const da_empty_cart_title = /** @type {(inputs: {}) => string} */ () => {
	return `Tom kurv`
};

const de_empty_cart_title = /** @type {(inputs: {}) => string} */ () => {
	return `Warenkorb leer`
};

const en_empty_cart_title = /** @type {(inputs: {}) => string} */ () => {
	return `Shopping Cart is Empty`
};

const es_empty_cart_title = /** @type {(inputs: {}) => string} */ () => {
	return `Carrito vacío`
};

const fr_empty_cart_title = /** @type {(inputs: {}) => string} */ () => {
	return `Panier vide`
};

const hu_empty_cart_title = /** @type {(inputs: {}) => string} */ () => {
	return `Üres kosár`
};

const it_empty_cart_title = /** @type {(inputs: {}) => string} */ () => {
	return `Carrello vuoto`
};

const nl_empty_cart_title = /** @type {(inputs: {}) => string} */ () => {
	return `Winkelwagen leeg`
};

const pl_empty_cart_title = /** @type {(inputs: {}) => string} */ () => {
	return `Koszyk jest pusty`
};

const pt_empty_cart_title = /** @type {(inputs: {}) => string} */ () => {
	return `Carrinho vazio`
};

const sv_empty_cart_title = /** @type {(inputs: {}) => string} */ () => {
	return `Tom kundvagn`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const empty_cart_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.empty_cart_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("empty_cart_title", locale)
	if (locale === "cs") return cs_empty_cart_title(inputs)
	if (locale === "da") return da_empty_cart_title(inputs)
	if (locale === "de") return de_empty_cart_title(inputs)
	if (locale === "en") return en_empty_cart_title(inputs)
	if (locale === "es") return es_empty_cart_title(inputs)
	if (locale === "fr") return fr_empty_cart_title(inputs)
	if (locale === "hu") return hu_empty_cart_title(inputs)
	if (locale === "it") return it_empty_cart_title(inputs)
	if (locale === "nl") return nl_empty_cart_title(inputs)
	if (locale === "pl") return pl_empty_cart_title(inputs)
	if (locale === "pt") return pt_empty_cart_title(inputs)
	return sv_empty_cart_title(inputs)
};